import { Component, ComponentFactoryResolver, ComponentRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Platform, ViewWillEnter } from '@ionic/angular';
import { first } from 'rxjs/operators';
import { GameComponent } from 'src/app/components/game/game.component';
import { EventsService } from 'src/app/services/event/event.service';
import { GameHub } from 'src/app/services/gameHub/game-hub';
import { GameHubControllerService } from 'src/app/services/gameHub/game-hub-controller';
import { KeywordsService } from 'src/app/services/lobby/keywords.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';

@Component({
  selector: 'app-tab-game',
  templateUrl: 'tab-game.page.html',
  styleUrls: ['tab-game.page.scss']
})

export class TabGamePage implements ViewWillEnter {
  @ViewChild('gameComponentContainer', { read: ViewContainerRef })
  viewRef: ViewContainerRef;
  
  public isMobileOrMobileWeb: boolean;
  public isIOSApp: boolean;
  public isAuthenticated: boolean;
  private gameInstance: any;
  private lobbyNameParam: string;
  private isMobile: boolean;
  private isMobileWeb: boolean;
  private isCordova: boolean;
  private isCapacitor: boolean;
  private componentRef: ComponentRef<GameComponent>;
  private children: Map<string, ComponentRef<GameComponent>> = new Map();

  constructor(
    private gameHubService:GameHub,
    private gameHubControllerService:GameHubControllerService,
    private platform: Platform,
    private userSessionService: UserSessionService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private eventsService: EventsService,
    private keywordService:KeywordsService
  ){
    
    this.keywordService.getKeyword().subscribe(keyword => {
      this.lobbyNameParam = keyword;
    });

    this.eventsService.subscribe('event:gameHub:removeGame', (id) => {
      this.removeComponent(id);
    });
  }

  ionViewWillEnter() {
    this.checkForPlatform();
    this.checkAuthentication();
    this.gameHubControllerService
      .getFocusedInstance().pipe(first())
      .subscribe((instanceId) => {  
        if (!!instanceId) {
          let instance = this.gameHubService.getInstance(instanceId);
          if (
            (instance.model.getInstanceCategoryType() == 'casino-game' &&
              !!instanceId) ||
            this.platform.is('mobile')
          ) {
            this.loadGameInstance(instanceId);
          }
        } else {
          this.eventsService.publish('action:changeTab', 'casino');
        }
      });
  }

  checkForPlatform() {
    this.isIOSApp = this.platform.is('ios');
    this.isCordova = this.platform.is('cordova');
    this.isCapacitor = this.platform.is('capacitor');
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
    this.isMobileWeb = this.isMobile&&!(this.isCapacitor||this.isCordova);
    this.isMobileOrMobileWeb = this.isMobile || this.isMobileWeb;
  }

  checkAuthentication() {
      this.userSessionService._sessionTokenSubject.subscribe(() => {
        this.userSessionService
          .isAuthenticated()
          .then((isAuthenticated) => (this.isAuthenticated = isAuthenticated));
      });
  }

  removeComponent(id) {
      if (this.children.has(id)) {
        try {
          this.componentRef.instance.toggleFullScreen(true);
          let iframe: any = document.getElementById(`iframe_${id}`);
          iframe.contentWindow.postMessage({ action: 'close_game' }, '*');    
        } catch (e) {}
        setTimeout(() => {
          this.children.get(id).hostView.destroy();
          this.children.set(id, undefined);
        }, 200);
      }
  }

  loadGameInstance(instanceId: string) {
        const instance = this.gameHubService.getInstance(instanceId);
        this.gameInstance = instance['model'];
        let gameComponent = this.createComponent(instanceId);
        this.children.set(instanceId, gameComponent);
  }

  createComponent(instanceId: string) {
      const instanceIdInt = Number.parseInt(instanceId);
      const factory = this.componentFactoryResolver.resolveComponentFactory(GameComponent);
      
      this.viewRef.clear();
      this.componentRef = this.viewRef.createComponent(factory);
      this.componentRef.instance.setPlatforms({
        isMobile: this.isMobile,
        isMobileOrMobileWeb: this.isMobileOrMobileWeb,
        isMobileWeb: this.isMobileWeb,
        isCordova: this.isCordova,
        isCapacitor: this.isCapacitor,
        isIOSApp: this.isIOSApp,
      });

      let sessionToken = this.userSessionService.getSessionToken();

      this.componentRef.instance.setInstanceId(instanceIdInt);  
      this.componentRef.instance.setGameUrl(this.gameInstance.url, sessionToken, this.gameInstance.is_demo, this.gameInstance.super_type);
      return this.componentRef;
  }


}
